import { memo } from "react";
import { Onboarding } from "../common";
import {
    BusinessInformationLabel,
    BankingAndFinanceLabel,
    MediaAndComplianceCheckLabel,
    UBOIdentityVerificationLabel,
    PaymentMethodsLabel
} from "./steps";
import { useOnboardingApplication } from "./hooks";
import { WebRoutes } from "consts/enpoints/web";

const OnboardingMerchant = () => {
    const {
        getApplicationModel
    } = useOnboardingApplication();

    return (
        <Onboarding
            route={WebRoutes.Onboarding.Merchant}
            getApplicationModel={getApplicationModel}
        >
            <BusinessInformationLabel />
            <BankingAndFinanceLabel />
            <MediaAndComplianceCheckLabel />
            <UBOIdentityVerificationLabel />
            <PaymentMethodsLabel />
        </Onboarding>
    );
};

export default memo(OnboardingMerchant);
